import { FieldObject } from '~/interfaces/field.interface';
import { VeluxModule } from '~/models/modules/velux/VeluxModule.model';

export class NXB extends VeluxModule {
    get fieldSetupDate(): FieldObject | undefined {
        return undefined;
    }
    get fieldFirmware(): FieldObject | undefined {
        return undefined;
    }
    get fieldLastUpdate(): FieldObject | undefined {
        return undefined;
    }
    get fieldRoom(): FieldObject | undefined {
        return undefined;
    }
    get fieldRefurbished(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer2(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand2(): FieldObject | undefined {
        return undefined;
    }
}
